import { MatDialog } from '@angular/material';
import { Component, OnInit } from '@angular/core';
import { UserService } from '../_service/user.service';
import { AlertifyService } from '../_service/alertify.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../_service/auth.service';
import { AuthConfigService } from '../_service/auth-config.service';
import { LoginComponent } from '../login/login.component';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'completeuserregistration',
  templateUrl: './completeuserregistration.component.html',
  styleUrls: ['./completeuserregistration.component.css']
})
export class CompleteuserregistrationComponent implements OnInit {

  constructor(private userService: UserService,
    private alertify: AlertifyService,
    private router: Router,
    private route: ActivatedRoute,
    public authService: AuthService,
    public authConfigService: AuthConfigService,
    public dialog: MatDialog,
    public fb: FormBuilder
    ) 
    {
      this.completeRegistrationForm = fb.group({
        emailFormControl : new FormControl('', []).clearValidators(),
        firstNameFormControl : new FormControl('', [
          Validators.required,
          Validators.maxLength(50),
          this.WhitespaceValidator
        ]),
        lastNameFormControl : new FormControl('', [
          Validators.required,
          Validators.maxLength(70),
          this.WhitespaceValidator
        ]),
        passwordFormControl:  new FormControl('', [
          Validators.required,
          this.WhitespaceValidator,
          Validators.minLength(6),
          Validators.maxLength(20),
          Validators.pattern('^(?=[^a-z]*[a-z])(?=.*[0-9])(?=[^A-Z]*[A-Za-z]).{6,20}$')
        ]),
        confirmPasswordFormControl:  new FormControl('', [
          Validators.required,
          this.WhitespaceValidator
        ]),
      }, {
        validators: this.MustMatch('passwordFormControl', 'confirmPasswordFormControl')
      });
     }

    hide = true;
    password;
    confirmPassword;
    email: any;
    model: any = {};
    profileCreated: any = {};
    profileCreationError: any = {};
    profileExistsError: any = {};
    completeRegistrationForm: FormGroup;
    isLoading = false;


    public MustMatch(controlName: string, matchingControlName: string) {
      return (formGroup: FormGroup) => {
          const control = formGroup.controls[controlName];
          const matchingControl = formGroup.controls[matchingControlName];
          if (matchingControl.errors && !matchingControl.errors.mustMatch) {
              // return if another validator has already found an error on the matchingControl
              return;
          }
          // set error on matchingControl if validation fails
          if (control.value !== matchingControl.value) {
              matchingControl.setErrors({ mustMatch: true });
          } else {
              matchingControl.setErrors(null);
          }
      }
  }

    public WhitespaceValidator(control: FormControl) {
      const isWhitespace = (control.value || '').trim().length === 0;
      const isValid = !isWhitespace;
      return isValid ? null : { 'whitespace': true };
  }

  ngOnInit() {
    console.log(this.completeRegistrationForm);
    this.email = this.route.snapshot.queryParams.email;
  }

   loginPrompt() {
            const dialogRef = this.dialog.open(LoginComponent, {
              width: '500px'
            });
          }

  completeRegistration() {
    this.model.password = this.completeRegistrationForm.get('passwordFormControl').value.trim();
    this.model.confirmPassword =  this.completeRegistrationForm.get('confirmPasswordFormControl').value.trim();

    if (this.model.password === this.model.confirmPassword) {

    this.model.email = this.route.snapshot.queryParams.email;
    this.model.code = this.route.snapshot.queryParams.code;

    this.model.firstName = this.completeRegistrationForm.get('firstNameFormControl').value.trim();
    this.model.lastName = this.completeRegistrationForm.get('lastNameFormControl').value.trim();

        this.isLoading = true;
        return this.userService.completeInviteeRegistration(this.model).subscribe(
          res => {
            this.isLoading = false;
            this.profileCreationError = res.headers.get('inviteerror');
            if (this.profileCreationError) {
              this.alertify.error(this.profileCreationError);
              this.router.navigate(['/search']);
            }
            // Handle profile creation success based on authentication mode
            this.profileCreated = res.headers.get('profilesuccess');
            if (this.profileCreated) {
              this.alertify.success(this.profileCreated);
              this.router.navigate(['/search']);
              
              if (this.authConfigService.isWindowsAuthMode()) {
                this.authService.logout();
              } else {
                this.loginPrompt();
              }
            }

            this.profileExistsError = res.headers.get('profileexists');
            if (this.profileExistsError) {
              this.alertify.error(this.profileExistsError);
              this.router.navigate(['/search']);
            }

        }, error => {
          this.isLoading = false;
          this.alertify.error('Something went wrong!');
        });
      } else {
        this.alertify.error('Passwords do not match');
      }
  }
}